import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../../../store';
import {Website} from "../../../../website";
import {ActivityAction} from "../../../../../../activities/activity";
import { UserSubscription } from 'app/user/user-subscription';
import {filter, first, switchMap} from "rxjs/operators";
import {Config} from "../../../../../../config/config";
import {TypeUtils} from "../../../../../../shared/utils/type-utils";


@Component({
    selector: 'db-optimization-progress',
    templateUrl: './optimization-progress.component.html',
    styleUrls: ['./optimization-progress.component.scss'],
    standalone: false
})
export class OptimizationProgressComponent implements OnInit {

  public websiteUrl: string;
  public activity: any;
  public timeForThirdStep: number = 6000;
  public steps: any;
  public currentStep: number = 0;
  public progress: number = 0;
  public lastStep: boolean;
  public userLocalStorage: any;
  public websitesCount: number = 0;
  public Config = Config;
  @Input() websiteId: number;
  @Input() userSubscription: UserSubscription;
  @Output() readonly onResize: EventEmitter<[number, number]> = new EventEmitter<[number, number]>();

  constructor(
    private _store: Store<fromStore.DbStoreState>,
  ) { }

  ngOnInit() {
    this.steps = ['Optimizing the frontend', 'Compressing images'];
    this._changeStep();
    this._getWebsite();
    this._getWebsitesCount();
    this.websiteId && this._getOngoingActivities();
  }

  private _getWebsitesCount(): void {
    this._store.select(fromStore.getWebsites)
      .pipe(
        first(websites => !!websites)
      )
      .subscribe(websites => {
        this.websitesCount = websites.filter(website => !website.parentId && website.isActive && website.connectedFrom === 'speed_optimizer').length;
        this._getUserLocalStorage();
      });
  }

  private _getUserLocalStorage(): void {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUserLocalStorage)),
        first()
      )
      .subscribe((userLocalStorage: any) => {
        this.userLocalStorage = userLocalStorage;
        this._resize();
      });
  }

  private _getOngoingActivities(): void {
    this._store.select(fromStore.getOngoingActivities)
      .subscribe((ongoingActivities): void => {
        const activity = ongoingActivities.find((activity): boolean => activity.action === ActivityAction.OPTIMIZING_FIRST_PAGE);
        if ((!activity || !(activity && activity.meta && activity.meta.steps)) && !this.currentStep) {
          this.currentStep = 0;
        }
        else if (activity && activity.meta && activity.meta.steps) {
          this._changeStep();
        }
    });
  }

  private _changeStep(): void {
    setTimeout(() => {
      this.currentStep = 1;
    }, 7000);
  }

  private _getWebsite(): void {
    this._store.select(fromStore.getWebsite(this.websiteId))
      .pipe(
        first(website => !!website)
      )
      .subscribe((website: Website): void => {
        if (!TypeUtils.isNull(website)) {
          this.websiteUrl = website && website.site_url.replace(/^https?:\/\//i, '');
        }
      });
  }

  private _resize(): void {
    const height = this.userLocalStorage && !this.userLocalStorage.verifyEmailErrorClosed && this.websitesCount < 2 ? 388 : 336;
    this.onResize.emit([height, 470]);
  }

}
